import { Button, FloatingLabel, FormControl, InputGroup } from "react-bootstrap";
import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PasswordWithShow = ({
	className,
	isInvalid,
	isValid,
	name,
	onBlur,
	onChange,
	placeholder,
	required,
	value
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const toggleShowPassword = useCallback(() => setShowPassword((cur) => !cur), []);
	return (
		<InputGroup
			className={classNames("w-100", "password-with-show", className, {
				"is-invalid": isInvalid,
				"is-valid": isValid
			})}
		>
			<FloatingLabel
				className="flex-fill"
				controlId={name}
				label={placeholder}
			>
				<FormControl
					isInvalid={isInvalid}
					isValid={isValid}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					placeholder={placeholder}
					required={required}
					type={showPassword ? "text" : "password"}
					value={value}
				/>
			</FloatingLabel>
			<Button onClick={toggleShowPassword} size="sm" tabIndex={-1} variant="link">
				{showPassword ? "Hide" : "Show"}
			</Button>
		</InputGroup>
	);
};

PasswordWithShow.propTypes = {
	className: PropTypes.string,
	isInvalid: PropTypes.bool,
	isValid: PropTypes.bool,
	name: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	value: PropTypes.string
};

PasswordWithShow.defaultProps = {
	className: "",
	isInvalid: false,
	isValid: false,
	name: "password",
	onBlur: () => null,
	placeholder: "Password",
	required: false,
	value: ""
};

export default PasswordWithShow;
